import config from "@/config";
import type { CurrentUser } from "@/types/user";

/**
 * Returns true if the Lead Finder feature should be available to this user.
 *
 * - Development / staging: available to all authenticated users (unrestricted for testing)
 * - Production: gated behind the `leadFinderEnabled` flag on the licensee
 */
export function canAccessLeadFinder(user?: CurrentUser | null): boolean {
  if (!user) return false;
  if (config.env !== "production") return true;
  return !!user.leadFinderEnabled;
}
